<script>
  let {
    totalCount = 0,
    countPerPage = 1,
    currentPage = 0,
    onClick = () => {},
    dictionary = {},
  } = $props();

  import { DESKTOP_MIN_WIDTH } from '../../assets/js/constants';

  let screenWidth = $state(window.innerWidth);
  let isDesktop = $derived(screenWidth > DESKTOP_MIN_WIDTH);

  let countOfPages = $derived(Math.ceil(totalCount / countPerPage));

  window.addEventListener('resize', () => {
    screenWidth = window.innerWidth;
  });

  function scrollToTop() {
    const el = document.getElementsByName('resultTopScroll')[0];
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  function onClickArrow(direction) {
    let page = currentPage;

    if (direction === 'next' && page !== countOfPages) {
      page += 1;
    } else if (direction === 'prev' && page !== 0) {
      page -= 1;
    }
    currentPage = page;
    onClick(page);
    scrollToTop();
  }

  function onClickNumber(page) {
    currentPage = page;
    onClick(page);
    scrollToTop();
  }

  // Directly ported from pagination.js
  // I'm sorry.
  function shouldShowButtonNumber(i) {
    if (isDesktop) {
      return (
        i === 0 ||
        i === countOfPages - 1 ||
        (i > countOfPages - 7 && currentPage > countOfPages - 6) ||
        (i < 6 && currentPage < 5) ||
        countOfPages === 8 ||
        (currentPage >= i - 2 && currentPage <= i + 2)
      );
    } else {
      return (
        i === 0 ||
        i === countOfPages - 1 ||
        (i > countOfPages - 4 && currentPage > countOfPages - 3) ||
        (i < 3 && currentPage < 3) ||
        (i === 1 && currentPage === 3) ||
        (i === countOfPages - 2 && currentPage === countOfPages - 4) ||
        (currentPage >= i - 1 && currentPage <= i + 1)
      );
    }
  }
</script>

{#if totalCount > countPerPage}
  <ul class="pagination__list" data-search-pagination>
    <li>
      <button
        type="button"
        title={dictionary.Previous ?? 'Previous'}
        class="pagination__prev"
        disabled={currentPage === 0}
        onclick={() => onClickArrow('prev')}
        rel="prev"
      >
        <svg class="icon" aria-hidden="true" focusable="false">
          <use href="/assets/images/svg/spritemap#icon-arrow-right"></use>
        </svg>
      </button>
    </li>

    {#each { length: countOfPages }, i}
      {#if shouldShowButtonNumber(i)}
        <li>
          <button
            type="button"
            class="pagination__btn {i === currentPage
              ? 'button__primary is-active'
              : ''}"
            onclick={() => onClickNumber(i)}
          >
            {i + 1}
          </button>
        </li>
      {:else if i === 1 || i === countOfPages - 2}
        <li><span>...</span></li>
      {/if}
    {/each}

    <li>
      <button
        type="button"
        title={dictionary.Next ?? 'Next'}
        class="pagination__next"
        disabled={currentPage === countOfPages - 1}
        onclick={() => onClickArrow('next')}
        rel="next"
      >
        <svg class="icon" aria-hidden="true" focusable="false">
          <use href="/assets/images/svg/spritemap#icon-arrow-right"></use>
        </svg>
      </button>
    </li>
  </ul>
{/if}
